/**************************************************
 * Nombre:       Home_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import Tarjeta_Banner from "../../Tarjetas/Tarjeta_Banner";
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../../../App";

const Home_Portada = () => {
    const cData = useContext(contexApp)
    const [anuncios, setAnuncios] = useState([]);

    useEffect(() => {

        if (cData.anuncios) {
            setAnuncios(cData.anuncios);
        }

    }, [cData])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{mt: -12}}
        >


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Splide
                    aria-label="My Favorite Images" style={{width: '100%'}}
                    options={{
                        autoplay: true,
                        speed: 1500,
                        rewind: true,
                        perPage: 1,
                        arrows: false,
                        pagination: false,
                        width: '100%',
                        drag: false,
                        interval: 8000,
                        noDrag: true,
                        type: 'loop',


                    }}
                >

                    {anuncios.map((item, index) => {
                        return (
                            <SplideSlide key={`qe${index}`}>
                                <Tarjeta_Banner item={item}/>
                            </SplideSlide>
                        )
                    })}


                </Splide>


            </Grid>

        </Grid>
    )

}
export default Home_Portada

const banners = [1, 2, 3]